export class LicenseException extends Error
{

}
